<template>
  <Teleport to="body">
    <div class="session-timeout-alerts">
      <v-alert
        v-if="timeout"
        type="success"
        max-height="60"
        class="overflow-visible"
        position="fixed"
        width="100%"
        style="top: 0; left: 0; z-index: 3000"
      >
        長時間操作が行われなかったため、自動的にログアウトされました
      </v-alert>
      <v-alert
        v-if="showApproachingAlert"
        type="warning"
        max-height="60"
        class="overflow-visible d-flex align-center"
        position="fixed"
        width="100%"
        style="top: 0; left: 0; z-index: 3000"
      >
        一定時間操作が行われていない場合、自動的にログアウトされます
        <template #close>
          <v-btn
            size="medium"
            class="close-btn"
            aria-label="閉じる"
            @click="hideTimeoutApproachingAlert"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-alert>
    </div>
  </Teleport>
</template>

<script setup>
import { computed, ref, watch } from "vue";

const props = defineProps({
  timeout: {
    type: Boolean,
    required: true
  },
  timeoutApproaching: {
    type: Boolean,
    required: true
  }
});

const isApproachingAlertDismissed = ref(false);

const showApproachingAlert = computed(() => {
  // タイムアウト確定後は approaching が true のまま残り得るため、ログアウト通知（timeout）と
  // 承認前アラートが同じ位置に二重表示されないよう、timeout 中は承認前アラートを出さない。
  return props.timeoutApproaching && !props.timeout && !isApproachingAlertDismissed.value;
});

watch(() => props.timeoutApproaching, (newValue) => {
  if (!newValue) {
    isApproachingAlertDismissed.value = false;
  }
});

const hideTimeoutApproachingAlert = () => {
  isApproachingAlertDismissed.value = true;
};
</script>

<style scoped>
.close-btn {
  position: absolute;
  right: 10px;
  top: 14px;
}
</style>
